import { render, staticRenderFns } from "./SurveyFooter.vue?vue&type=template&id=2cb81730&lang=pug"
import script from "./SurveyFooter.vue?vue&type=script&lang=js"
export * from "./SurveyFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AutosaveStatus: require('/home/docker/code/frontend/components/AutosaveStatus.vue').default})
